import jsCookie from 'js-cookie';
import React, {
  createContext,
  Dispatch,
  PropsWithChildren,
  useReducer,
} from 'react';

import { IPeriodicJobs } from '@/modules/periodicJobs/types';

import { Actions, periodicJobsReducer } from './reducer';

/******************************************************************************************
      NOTE: Add any global data for PeriodicJobs module ex: advanced fillter
/*************************************************************************************** */

export type InitialStateType = {
  startDate: Date | null;
  endDate: Date | null;
  selectedPlots: Array<IPeriodicJobs.Plot>;
  selectedCrop: IPeriodicJobs.CropSchema | null;
  tablePageNumber: number;
};

const tempSD = new Date();
tempSD.setDate(tempSD.getDate() - 7);

const savedCrop = jsCookie.get('periodicJobsCrop');

const initialState: InitialStateType = {
  startDate: new Date(tempSD),
  endDate: new Date(),
  selectedPlots: [],
  selectedCrop: savedCrop ? JSON.parse(savedCrop) : null,
  tablePageNumber: 1,
};

const PeriodicJobsContext = createContext<{
  state: InitialStateType;
  dispatch: Dispatch<Actions>;
}>({
  state: initialState,
  dispatch: () => null,
});

const PeriodicJobsProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [state, dispatch] = useReducer(periodicJobsReducer, initialState);

  return (
    <PeriodicJobsContext.Provider value={{ state, dispatch }}>
      {children}
    </PeriodicJobsContext.Provider>
  );
};

export { PeriodicJobsContext, PeriodicJobsProvider };
